import { VFC } from 'react';
import styled from 'styled-components';
import { useUser } from '../hooks/useUser';
import { ReactComponent as LogoutIcon } from '../static/logout.svg';

const ContentHeader = styled.header`
    background: ${props => props.theme.colors.white};
    padding: ${props => props.theme.spacing[7]};
    margin-bottom: ${props => props.theme.spacing[7]};
    display: flex;
    align-items: center;
    /* border-bottom: 1px solid ${props => props.theme.colors.gray[1]}; */
    box-shadow: ${props => props.theme.shadows.md};
`;

const HeaderLabel = styled.span`
    font-size: ${props => props.theme.fontSize[3]};
    font-weight: bold;
`;

const HeaderActions = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
`;

const LogoutButton = styled.button`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    border: 0;
    border-radius: ${props => props.theme.radius.full};
    background-color: ${props => props.theme.colors.primary[3]};
    cursor: pointer;
    padding: ${props => props.theme.spacing[2]} ${props => props.theme.spacing[5]};
    padding-right: ${props => props.theme.spacing[6]};
    gap: ${props => props.theme.spacing[3]};
    font-size: ${props => props.theme.fontSize[1]};
    font-weight: bold;
    font-family: adelle-sans;
    color: ${props => props.theme.colors.white};
    stroke: ${props => props.theme.colors.white};
    transition: .25s ease;

    &:hover,
    &:focus,
    &:active {
        background-color: ${props => props.theme.colors.primary[4]};
    }
`;

const UserStatus = styled.span`
    display: inline-block;
    margin-right: ${props => props.theme.spacing[6]};
    font-weight: bold;
    font-family: adelle-sans;

    span {
        display: block;
        font-weight: normal;
        color: ${props => props.theme.colors.gray[6]};
        margin-bottom: ${props => props.theme.spacing[1]};
    }
`;

export const Header: VFC = () => {
    const { user, logoutUser } = useUser();
    const userStatus = user?.hasCustomer ? user.name : 'Ej registrerad kund';

    return (
        <ContentHeader>
            <HeaderLabel>
                Social Connect
            </HeaderLabel>
            <HeaderActions>
                <UserStatus>
                    <span>Inloggad som</span>
                    {userStatus}
                </UserStatus>
                <LogoutButton onClick={() => logoutUser()}>
                    <LogoutIcon />
                    Logga ut
                </LogoutButton>
            </HeaderActions>
        </ContentHeader>
    );
}
